import React from 'react'

export default function Ceo() {
  return (
    <>
    <div className='justify-center items-center overflow-hidden md:py-20 py-10 bg-[#e4e4e4]'>
        <div className='max-w-screen-xl justify-center mx-auto'>
            <div className='max-w-screen-xl md:px-16 px-5 md:py-8 md:justify-center mx-auto text-black'>
                <div className='mx-auto justify-between'>
                    <div className='md:py-5 pt-2 md:pb-0 pb-5'>
                        <h1 className='md:text-2xl text-sm tracking-wide text-[#474747]'>
                            "The paramount achievements of our organization are a testament to our most prized asset: our people. 
                            I frequently emphasize that in the realm of finance, patents hold no dominion. Rather, 
                            our prosperity is rooted in the exceptional talents of our global teams, intricately woven together by a shared, unwavering commitment to be peerless in our field, 
                            serving the best interests of our valued investors"
                        </h1>
                        <h1 className='pt-8 uppercase md:text-base text-sm text-[#c49f3a]'>Zoaib Ali</h1>
                        <p className='uppercase md:text-base text-sm text-[#c49f3a]'>CEO & Managing Director</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}
